<template>
  <nav class="tab-nav">
    <tab-nav-item
      :exact="tab.exact"
      :route="tab.route"
      v-for="(tab, i) in tabs"
      :key="i"
    >
      {{ tab.title }}
    </tab-nav-item>
    <div
      class="tab-nav__indicator"
      :style="
        `transform: translateX(${this.indicatorPosition}%); width: ${100 /
          this.tabs.length}%`
      "
    ></div>
  </nav>
</template>

<script>
import TabNavItem from './TabNavItem';
export default {
  name: 'tabbed-nav',
  props: {
    tabs: {
      type: [Array],
      required: true,
    },
  },
  computed: {
    activeElement() {
      const currentRoute = this.$route.name;

      const routes = [...this.tabs];
      let activeIndex = 0;
      routes.forEach((route, index) => {
        if (route.route === currentRoute) {
          activeIndex = index;
        }
      });
      return activeIndex;
    },
    indicatorPosition() {
      return this.activeElement * 100;
    },
  },
  components: { TabNavItem },
};
</script>

<style lang="scss" scoped>
.tab-nav {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-bottom: 1px solid color('grey');
  position: relative;
  margin-bottom: 32px;
  background: color('background', 'light');

  .tab-nav__indicator {
    content: '';
    height: 4px;
    bottom: -2px;
    border-radius: 4px;
    background: color('primary');
    position: absolute;
    transition: all 128ms ease-in-out;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  }
}
</style>
